// import { OrderType } from "../types";
import { OrderCreation } from "types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all orders
export const getOrders = async (branch_id?: string | number) => {
  const url = branch_id
    ? `${ServiceEndpoints.ORDERS}?branch_id=${branch_id}`
    : ServiceEndpoints.ORDERS;
  return axios
    .get(url)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new order
export const createOrder = async (data: FormData) => {
  return axios
    .post(ServiceEndpoints.ORDERS, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an order by ID
export const updateOrder = async (id: string, data: OrderCreation) => {
  console.log("Update data: ", data);
  return axios
    .put(`${ServiceEndpoints.ORDERS}/${id}`, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update a order status by ID
export const updateOrderStatus = async (
  id: string,
  data: { status: string }
) => {
  const { ...orderData } = data;

  return axios
    .patch(`${ServiceEndpoints.ORDERS}/${id}/status?status=${orderData.status}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get an order by its ID
export const getOrderById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.ORDERS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete an order by ID
export const deleteOrder = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.ORDERS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
